const messages = {
}
export default messages;


// WEBPACK FOOTER //
// ./src/locale/en.js